import { APIClient } from '../api_helper';
import { api } from '../../config';
import * as url from './url_helper';
import qs from 'qs';

const apiClient = new APIClient(api.REACT_APP_SPED_WEATHER_API_URL);

export const stringifyParams = params => qs.stringify(params, { encodeValuesOnly: true });


export const getDataWeatherData = params => { return apiClient.post(`${url.GET_DATA_WEATHER_FORECAST}?${stringifyParams(params)}`); };
export const getDataWeatherCurrent = params => { return apiClient.get(`${url.GET_DATA_WEATHER_CURRENT}?${stringifyParams(params)}`); };

